import { usePrivateUrl } from "@/components/private-image";

const AVATAR_PALETTE = [
  "#ef4444",
  "#f97316",
  "#eab308",
  "#22c55e",
  "#14b8a6",
  "#06b6d4",
  "#3b82f6",
  "#8b5cf6",
  "#ec4899",
  "#f43f5e",
  "#84cc16",
  "#a78bfa",
];

export function avatarColor(email: string): string {
  let h = 0;
  for (let i = 0; i < email.length; i++) {
    h = ((h << 5) - h + email.charCodeAt(i)) | 0;
  }
  return AVATAR_PALETTE[Math.abs(h) % AVATAR_PALETTE.length];
}

export function avatarInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return (parts[0]?.slice(0, 2) ?? "?").toUpperCase();
}

export function ClientAvatar({
  name,
  email,
  photoUrl,
  size = 36,
  onClick,
  uploading,
  headers = {},
}: {
  name: string;
  email: string;
  photoUrl?: string | null;
  size?: number;
  onClick?: () => void;
  uploading?: boolean;
  headers?: Record<string, string>;
}) {
  const color = avatarColor(email);
  const inits = avatarInitials(name);
  const base = {
    width: size,
    height: size,
    borderRadius: "50%",
    flexShrink: 0 as const,
    display: "block" as const,
    cursor: onClick ? "pointer" : "default",
  };

  const { blobUrl, loading } = usePrivateUrl(photoUrl, headers);
  const resolvedSrc = blobUrl;

  if (photoUrl && !loading && resolvedSrc) {
    return (
      <img
        src={resolvedSrc}
        alt={name}
        onClick={onClick}
        title={onClick ? "Change photo" : name}
        style={{
          ...base,
          objectFit: "cover",
          border: `2px solid ${color}55`,
        }}
      />
    );
  }

  return (
    <div
      onClick={onClick}
      title={onClick ? "Upload photo" : name}
      style={{
        ...base,
        background: `${color}22`,
        border: `2px solid ${color}55`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: Math.round(size * 0.33),
        fontWeight: 700,
        color,
        userSelect: "none",
        position: "relative",
      }}
    >
      {uploading ? "…" : inits}
    </div>
  );
}
